<template>
    <ModalFormCard class="w-full lg:max-w-[800px] modal-default" :action="action" v-bind="{ errors, saving }">
        <template #title
            ><p>{{ $help.capitalizeFirstLetter(image.url !== undefined ? image.name : options.title) }}</p></template
        >

        <div class="flex items-center justify-center p-2">
            <!-- <img :src='image.url != undefined ? image.url : image'
				class='h-full w-full object-cover'
				v-if='["pdf","ai"].indexOf(image.ext) === -1'
			/> -->

            <img :src="image.url !== undefined ? image.url : image" class="w-auto max-h-[880px]" @error="showNoPreview = true" v-if="!showNoPreview" />

            <div class="w-full h-[600px] bg-grey-300 flex items-center justify-center" v-if="showNoPreview">
                <p class="text-15">No preview available</p>
            </div>
        </div>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    created() {
        // this.setup(Note)
    },

    data() {
        return {
            showNoPreview: false,
        }
    },

    computed: {
        image() {
            return this.editingModel
        },
    },
}
</script>
